var exports = {
  "kL": "xfb577c5e--248bc9--container",
  "Kk": "xfb577c5e--248bc9--icon",
  "DD": "xfb577c5e--248bc9--title",
};

module.exports = exports;
